/**
 * Opens an external URL in the system browser.
 * In a Capacitor app this uses the Browser plugin; on web it falls back to window.open.
 */
export async function openExternalLink(url) {
  if (!url) return;

  try {
    const { Browser } = await import('@capacitor/browser');
    await Browser.open({ url, windowName: '_blank' });
  } catch {
    window.open(url, '_blank', 'noopener,noreferrer');
  }
}
